module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 text-left"
  }, [(_vm.roleType === 30) ? _c('div', {
    staticClass: "m-b-15"
  }, [_vm._v("\n        會員總數： " + _vm._s(_vm.total) + " 人\n      ")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginType),
      expression: "loginType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.loginType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getMemberList(1)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 登入類型 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("手機")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Line")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("街口")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("車廠")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("品牌既有會員")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType === 99) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("信箱")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("手機")]), _vm._v(" "), (_vm.roleType === 99) ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("暱稱")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("會員ID")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("編號")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.result),
      expression: "search.result"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.result)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "result", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("編號")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("ID")]) : _vm._e(), _vm._v(" "), (_vm.hasExistingMember && (_vm.roleType === 30 || _vm.roleType === 10)) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("品牌既有會員 ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("手機")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    staticStyle: {
      "min-width": "72px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("登入類型")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("手機認證")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("開通")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("權限")]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("性別")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("信箱")]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("生日")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("建立時間")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("整合狀態")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("是否為訪客")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("訂單記錄")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("整合紀錄")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.memberList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.memberList.length > 0) ? _c('tbody', _vm._l((_vm.memberList), function(member, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('router-link', {
      attrs: {
        "to": {
          path: 'memberInfo/' + member.shopper_id
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(member.user_no))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30 || _vm.roleType === 10) ? _c('span', [_vm._v(_vm._s(member.user_no))]) : _vm._e()], 1), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(member.shopper_id))]) : _vm._e(), _vm._v(" "), (_vm.hasExistingMember && (_vm.roleType === 30 || _vm.roleType === 10)) ? _c('td', [_vm._v("\n            " + _vm._s(member.vendor_custom_user_no) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.nickname)), (member.last_name || member.first_name) ? _c('span', [_vm._v(" (" + _vm._s(member.last_name) + _vm._s(member.first_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.phone))]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.create_account_type == 1) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/phone-v2.svg"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 2) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/fb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 3) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/google.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 4) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "src": "/static/img/icon/line.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_owner_type == 2 && member.create_account_type == 4) ? _c('span', [_vm._v("\n              (" + _vm._s(member.create_account_owner_brand_name) + ")\n            ")]) : (member.create_account_owner_type == 1 && member.create_account_type == 4) ? _c('span', [_vm._v("\n              (你訂)\n            ")]) : _vm._e(), _vm._v(" "), (member.create_account_type == 5) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/jkos.svg"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 6) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/car.png"
      }
    })]) : _vm._e(), _vm._v(" "), (member.create_account_type == 7) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/existing-member.png",
        "alt": "品牌既有會員"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(member.create_account_owner_brand_name))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.is_phone_valid) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("通過")]) : _vm._e(), _vm._v(" "), (!member.is_phone_valid) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未通過")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.is_active) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟動")]) : _vm._e(), _vm._v(" "), (!member.is_active) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟動")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(!member.is_suspend) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (member.is_suspend) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("停權")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('td', [(member.sex == 1) ? _c('span', {
      staticClass: "text-blue"
    }, [_c('i', {
      staticClass: "fa fa-male",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (member.sex == 2) ? _c('span', {
      staticClass: "text-red"
    }, [_c('i', {
      staticClass: "fa fa-female",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(member.email))]) : _vm._e(), _vm._v(" "), (_vm.roleType !== 10) ? _c('td', [_vm._v(_vm._s(member.birth))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(member.create_time))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [(member.is_integrated === 1 && member.integrated_shopper_list.length > 0) ? _c('span', {
      staticClass: "tag-default text-white bg-blue"
    }, [_vm._v("\n              主帳號\n            ")]) : (member.is_integrated === 1 && member.integrated_shopper_list.length === 0) ? _c('span', {
      staticClass: "tag-default text-white bg-orange"
    }, [_vm._v("\n              副帳號\n            ")]) : _c('span', {
      staticClass: "tag-default text-white bg-gray-2"
    }, [_vm._v("\n              尚未整合\n            ")])]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(member.is_guest ? '是' : '否'))])]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/memberOrderTable/' + member.shopper_id
        },
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-list-alt",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1), _vm._v(" "), (_vm.roleType === 99 && member.integrated_shopper_list) ? _c('td', [(member.integrated_shopper_list.length > 0) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/upgradememberInfo/' + member.shopper_id
        },
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": require("../../../../assets/icon/clipboard-list.svg"),
        "alt": "point_icon"
      }
    })])]) : (member.is_integrated && member.main_shopper_id) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/upgradememberInfo/' + member.main_shopper_id
        },
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": require("../../../../assets/icon/clipboard-list.svg"),
        "alt": "point_icon"
      }
    })])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upMember/' + member.shopper_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 1) : _vm._e()])
  }), 0) : _vm._e()])]), _vm._v(" "), (_vm.memberList.length) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(5)])], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "18"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2da288c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/Temp/MemberTableTemp.vue
// module id = 2370
// module chunks = 1